import Vue from 'vue'
import AppC from './AppC.vue'
import AppM from './AppM.vue'
import AppParallax from './AppParallax.vue'
import WPAPI from 'wpapi'

Vue.config.productionTip = false
Vue.prototype.$wp = new WPAPI({endpoint: 'https://lymberopoulos.anvetogroup.com/wp-json'})


new Vue({
  render: h => h(AppC),
}).$mount('#app2')

new Vue({
  render: h => h(AppM),
}).$mount('#app5')

new Vue({
  render: h => h(AppParallax),
}).$mount('#app7')
